// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0b74ed45","498":"624c22a3","545":"03ba5610"}[chunkId] + ".chunk.js";
};